export default __webpack_public_path__ + "static/media/rain.79438af1.mp3";